import { TenantConfigActionTypes, ITenantConfigFetchAsyncAction } from "./tenantConfigTypes"

export const fetchTenantConfigAsync = (): ITenantConfigFetchAsyncAction => {
  return {
    type: TenantConfigActionTypes.FETCH_TENANT_CONFIG_ASYNC_PENDING
  }
}
